import type { ModuleRoute } from '../types';
import { MembersPage } from './MembersPage';
import { ImportWizard } from './ImportWizard';

/** Pages of this area. Owned by Phase 1 task W2; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/groups/:id/members', element: <MembersPage />, permission: 'groups.view_members' },
  { path: '/manage/groups/:id/members/import', element: <ImportWizard />, permission: 'groups.manage_members' },
];
